import * as React from 'react';

import type {MessageStatus, ErrorReason} from 'nutshell-graphql-types';

import {Popover} from '../../../popover/popover';
import {Body} from '../../../typography/body';
import {useRefObserver} from '../../../utils/hooks/use-ref-observer';

import {getIcon, getStatusText, getErrorMessage} from './helpers';

type Props = {
    status: MessageStatus;
    scheduledTime?: number;
    errorReason?: ErrorReason | null | undefined;
};

export function MessageStatusText(props: Props) {
    const statusRef = React.useRef(null);
    const {isHovered} = useRefObserver(statusRef, ['isHovered']);

    return (
        <>
            <div className='flex nowrap' ref={statusRef}>
                <div className='mr-4 flex align-center'>{getIcon(props.status)}</div>
                <Body
                    getBodyRef={statusRef}
                    size='small'
                    color={props.status === 'FAILED' ? 'error' : 'light'}
                >
                    <span className='flex'>{getStatusText(props.status, props.scheduledTime)}</span>
                </Body>
            </div>
            {isHovered && props.errorReason && (
                <Popover anchor={statusRef.current} isNubDark={true} bodyColor='dark'>
                    <div className='pad-16'>
                        <Body color='white'>{getErrorMessage(props.errorReason)}</Body>
                    </div>
                </Popover>
            )}
        </>
    );
}
